import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { for: "pdf-service-filter" }
const _hoisted_2 = { for: "pdf-date-filter" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["title", "innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Download ")

import {
  NkButton,
  NkCol,
  NkDatePicker,
  NkGrid,
  NkGroup,
  NkStack,
  NkTable,
  NkTableColumn
} from '@/core/components';
import { computed, PropType, reactive, ref, Ref } from 'vue';
import { ElNotification } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { DeviceGroup } from '@/entities/device-group/types';
import { QueryFilters } from '@/types/services';
import { Service } from '@/entities/services/types';
import { InspectionGroupDetail } from '@/entities/inspection-group/types';
import { useGetServicesQuery } from '@/entities/services/hooks';
import { useGetInspectionGroupsDetailsQuery } from '@/entities/inspection-group/hooks';
import { formatDate } from '@/plugins/date-fns';
import { usePaginatedResponse } from '@/utils/query';
import { resume } from '@/plugins/resume';
import NvStack from '../../../core/components/layout/Stack/NkStack.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionBatchPDFDownload',
  props: {
  deviceGroupId: {
    type: Number as PropType<DeviceGroup['id']>,
    required: false
  }
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props






const { t } = useI18n();
const isLoading = ref(false);
const selectedInspectionGroup = ref<InspectionGroupDetail[]>([]);
const actionDisabled = computed(() => selectedInspectionGroup.value.length === 0 ?? !isLoading.value)
const formFilters: { service?: number[], date?: string[] } = reactive({});

const servicesQueryFilters = computed(() => ({
  'order[name]': 'asc'
}));
const { data: services } = useGetServicesQuery({}, servicesQueryFilters);

const groupsQueryFilters: Ref = computed(() => {
  const filters = {
    itemsPerPage: 1000,
  } as QueryFilters<InspectionGroupDetail> & {
    // eslint-disable-next-line camelcase
    device_group?: DeviceGroup['id'],
    'type'?: Service['id'][],
    'date[after]'?: string,
    'date[before]'?: string
  };

  if ( props.deviceGroupId ) {
    filters.device_group = props.deviceGroupId;
  }

  if ( formFilters.service ) {
    filters.type = formFilters.service;
  }

  if ( formFilters.date ) {
    [ filters['date[after]'], filters['date[before]'] ] = formFilters.date;
  }

  return filters;
});

const { data: inspectionGroupsDetails } = useGetInspectionGroupsDetailsQuery({}, groupsQueryFilters);
const { data: getGroupsDataValues } = usePaginatedResponse(inspectionGroupsDetails);
const selectable = (row: InspectionGroupDetail) => (row.report !== null);

const handleSelectionChange = (value: InspectionGroupDetail[]) => {
  selectedInspectionGroup.value = value;
};

const filepath = computed(() => `${process.env.VUE_APP_API_URL}/inspection_groups/reports?ids=${selectedInspectionGroup.value.map(i => i.id).join(',')}`)

const handlePDFDownload = async () => {
  isLoading.value = true;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const token = JSON.parse(localStorage.getItem(`auth-tokens-${process.env.NODE_ENV}`)!);
  try {
      const response = await fetch(filepath.value, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token.accessToken}`,
        }
      });

      const result = await response.json() as {token?: string, message?: string};

      if (result.token) {
        window.location.href = `${process.env.VUE_APP_API_BASE_URL}/download-reports/${result.token}`;
        ElNotification({
          title: t('notification.file_download_succes'),
          type: 'success',
          position: 'bottom-right',
        });
      }

      if (result.message) {
        ElNotification({
          title: t('notification.warning'),
          type: 'error',
          position: 'bottom-right',
          message: result.message
        });
      }
  } catch (e) {
    ElNotification({
      title: t('notification.error'),
      type: 'error',
      position: 'bottom-right',
    });
  } finally {
    isLoading.value = false;
    emit('close');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      _createVNode(_unref(NkGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkCol), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(NvStack, { spacing: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('inspection-group.form.field.service.label')), 1),
                  _createVNode(_component_el_select, {
                    modelValue: formFilters.service,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFilters.service) = $event)),
                    clearable: "true",
                    multiple: "true",
                    size: "large",
                    placeholder: "Filter by service",
                    class: "el-select-sav"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: service.id,
                          value: service.id,
                          label: service.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NkCol), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(NvStack, { spacing: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('inspection-group.form.field.date.label')), 1),
                  _createVNode(_unref(NkDatePicker), {
                    modelValue: formFilters.date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFilters.date) = $event)),
                    id: "pdf-date-filter",
                    type: "daterange",
                    "range-separator": "To",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkTable), {
        data: _unref(getGroupsDataValues),
        height: "350",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkTableColumn), {
            type: "selection",
            selectable: selectable
          }),
          _createVNode(_unref(NkTableColumn), {
            label: _ctx.$t('misc.park')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row?.deviceGroup ? scope.row?.deviceGroup : '-'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkTableColumn), {
            label: _ctx.$t('misc.turbine')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(NkGroup), {
                spacing: 2,
                "no-wrap": "",
                title: scope.row.device?.name || '-'
              }, {
                default: _withCtx(() => [
                  (scope.row.device?.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(resume)(scope.row.device?.name, 25)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                ]),
                _: 2
              }, 1032, ["title"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkTableColumn), {
            label: _ctx.$t('misc.type')
          }, {
            default: _withCtx((scope) => [
              (scope.row.service?.name && scope.row.service?.svg)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: scope.row.service?.name,
                    class: "inspection-table__service-icon",
                    innerHTML: scope.row.service?.svg
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkTableColumn), {
            "min-width": 150,
            label: _ctx.$t('misc.date')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(formatDate)(scope.row.date)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
            icon: "NkDownload",
            disabled: _unref(actionDisabled),
            onClick: handlePDFDownload
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_loading, isLoading.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})